<ac-layer acFor="let entity of entities$" [context]="this" [debug]="false">
    <ac-billboard-desc props="{ position: entity.position,
                          scale: 0.3,
                                                      }">
    </ac-billboard-desc>
    <!-- <ac-billboard-desc props="{ position: entity.position,
      image : './../../../../assets/images/geo-device.png',
      scale: 0.2,
                                  }"> 
    </ac-billboard-desc>-->
    <ac-label-desc props="{
                          position: entity.position,
                          text: entity.name,
                          scale: 0.7
                          }">
  </ac-label-desc>
  </ac-layer>
